import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadAppSettings } from './config/appSettings';

const root = ReactDOM.createRoot(document.getElementById('root'));

loadAppSettings().finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
